import type { RichEditorPreset } from '@odo/shared-ui';

// Case facts the note templates fill in; a missing one keeps its [placeholder].
export interface VcaNoteFields {
    doctorLastName: string | null;
    patientFirstName: string | null;
    currentAligner: number | null;
    /** MM/DD/YYYY. */
    datePosted: string | null;
}

export type VcaNotesPreset = (fields: VcaNoteFields) => RichEditorPreset;

export interface FilledNoteFields {
    doctor: string;
    patientFirstName: string;
    aligner: string;
    date: string;
}

export function filled(fields: VcaNoteFields): FilledNoteFields {
    return {
        doctor: fields.doctorLastName?.trim() || '[Last Name]',
        patientFirstName: fields.patientFirstName?.trim() || '[First Name]',
        aligner: fields.currentAligner != null ? String(fields.currentAligner) : '[#]',
        date: fields.datePosted?.trim() || '[Date]'
    };
}

// Card firstName can be blank on older records; fall back to the given name inside the full name,
// which is usually stored as "Last, First" and sometimes as "First Last".
export function resolvePatientFirstName(
    firstName: string | null | undefined,
    fullName: string | null | undefined
): string | null {
    const first = firstName?.trim();
    if (first) return first;
    return firstWordOfGivenName(fullName);
}

function firstWordOfGivenName(fullName: string | null | undefined): string | null {
    const name = fullName?.trim() ?? '';
    const commaIndex = name.indexOf(',');
    const givenPart = commaIndex === -1 ? name : name.slice(commaIndex + 1);
    return givenPart.trim().split(/\s+/)[0] || null;
}
